/**
 * Add `DevRouteName` to the `RouteName` type, and `routeNames` object in
 * the app.
 *
 * Example:
 * ```
 * export type RouteName = DashboardRouteName | ProRouteName | DevRouteName;
 *
 * export const routeNames = {
 *   ...DashboardRouteName,
 *   ...ProRouteName,
 *   ...DevRouteName,
 * };
 * ```
 */
var DevRouteName;
(function (DevRouteName) {
    DevRouteName["DEV_ADVANCED_SETTINGS"] = "Dev/AdvancedSettings";
    DevRouteName["DEV_TEST_TOOLING"] = "Dev/TestTooling";
})(DevRouteName || (DevRouteName = {}));

export { DevRouteName };
